import { getStoreState } from 'config/store'

export const hasSentImpression = () => {
  const { impressions = {} } = getStoreState()
  return impressions.hasSentImpression || false
}
